import {Component} from '@angular/core';
import {ErrorStreamService} from './error-stream.service';

declare var $: any;

@Component({ standalone: false, 
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
})
export class ErrorModalComponent {
  message: string;

  constructor(private errorStreamService: ErrorStreamService) {
    this.errorStreamService.catchStream$.subscribe((errorMsg: string) => {
      this.message = errorMsg;
      $('#errorModal').modal('show');
    });
  }
}
